import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function ShockIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg version="1.2" baseProfile="tiny-ps" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
        <path fill="none" d="M0 0L24 0L24 24L0 24L0 0Z" />
        <path d="M10.25 13.47L8.25 13.43L8.25 6.21L6.44 6.21C6 6.21 5.77 5.67 6.09 5.36L8.88 2.58C9.08 2.39 9.39 2.39 9.59 2.58L12.38 5.36C12.7 5.67 12.48 6.21 12.03 6.21L10.25 6.21L10.25 13.47Z" />
        <path d="M9.99 14.39L10.02 12.4L16.81 12.4L16.81 10.62C16.81 10.18 17.35 9.95 17.66 10.27L20.44 13.06C20.63 13.26 20.63 13.57 20.44 13.77L17.66 16.56C17.35 16.88 16.81 16.66 16.81 16.21L16.81 14.4L9.99 14.39Z" />
        <path d="M9.27 12.19L10.7 13.59L6.34 18.24L7.55 19.47C7.86 19.78 7.64 20.32 7.2 20.32L3.26 20.31C2.98 20.3 2.76 20.08 2.76 19.81L2.75 15.87C2.74 15.42 3.28 15.2 3.6 15.52L4.91 16.83L9.27 12.19Z" />
      </svg>
    </SvgIcon>
  );
}
